// Vendor libraries
import { BrowserModule } from '@angular/platform-browser';
import { StoreModule } from '@ngrx/store';
import { getLogger } from 'NewAngular/state/logger';
// Module imports
import { AccountSettingsNavigationModule } from 'AccountsApp/ts/features/navigation/account-settings-navigation.module';
import { ConfigModule } from 'NewAngular/config/config.module';
import { FormsModule } from '@angular/forms';
import { HelpModalModule } from 'NewAngular/features/components/modals/help-modal/help-modal.module';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { NavigationModule } from 'NewAngular/features/components/navigation/navigation.module';
import { SingleSelectDropdownModule } from 'NewAngular/features/components/dropdowns/single-select-dropdown/single-select-dropdown.module';
import { TooltipModule } from 'NewAngular/features/directives/popovers/tooltip/tooltip.module';
// Component imports
import { AccountSettingsNavigationComponent } from 'AccountsApp/ts/features/navigation/account-settings-navigation.component';
import { AccountNewsSourceSettingsComponent } from 'AccountsApp/ts/apps/account-user-preference-settings-app/components/news-source-settings/account-news-source-settings.component';
import { DarkmodePreferenceComponent } from 'AccountsApp/ts/apps/account-user-preference-settings-app/components/darkmode-preference/darkmode-preference.component';
import { DataMenuSettingPreferenceComponent } from 'AccountsApp/ts/apps/account-user-preference-settings-app/components/data-menu-setting-preference/data-menu-setting-preference.component';
import { QuickflowsPreferenceComponent } from 'AccountsApp/ts/apps/account-user-preference-settings-app/components/quickflows-preference/quickflows-preference.component';
import { NotificationPreferencesComponent } from 'AccountsApp/ts/apps/account-user-preference-settings-app/components/notification-preferences/notification-preferences.component';
import { SideMenuComponent } from 'NewAngular/features/components/side-menu/side-menu.component';
import { TopBarNavComponent } from 'NewAngular/features/components/navigation/top-bar-nav/top-bar-nav.component';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
export class AccountUserPreferenceSettingsModule {
}
AccountUserPreferenceSettingsModule.ɵfac = function AccountUserPreferenceSettingsModule_Factory(t) { return new (t || AccountUserPreferenceSettingsModule)(); };
AccountUserPreferenceSettingsModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: AccountUserPreferenceSettingsModule, bootstrap: [AccountSettingsNavigationComponent,
        AccountNewsSourceSettingsComponent,
        DarkmodePreferenceComponent,
        DataMenuSettingPreferenceComponent,
        NotificationPreferencesComponent,
        QuickflowsPreferenceComponent,
        TopBarNavComponent,
        SideMenuComponent] });
AccountUserPreferenceSettingsModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [AccountSettingsNavigationModule,
        BrowserModule,
        ConfigModule,
        FormsModule,
        HelpModalModule,
        NavigationModule,
        StoreModule.forRoot({}, { metaReducers: getLogger() }),
        SingleSelectDropdownModule,
        IconModule,
        TooltipModule] });
